export const frameworkInfos = [
  {
    key: "CUSTOM",
    value: "Custom Report",
    image: "/images/esg/custom.svg",
    summary: "Create a report using your company's custom disclosures.",
    usage:
      "Use when you need to report on custom metrics specific to your organization.",
    points: [
      "Uses only company custom disclosures from your library",
      "Fully customizable to your organization's needs",
      "Independent from standard frameworks",
    ],
    hideFromPicker: true,
  },
  {
    key: "UNIVERSAL",
    value: "Universal ESG Report",
    image: "/images/esg/universal.svg",
    summary:
      "Create a single report covering all supported frameworks at once.",
    usage:
      "Use when you need to report across multiple frameworks simultaneously.",
    points: [
      "Covers disclosures from all supported frameworks",
      "Fill shared metrics once — automatically maps to each framework",
      "Export as universal or per-framework report",
    ],
  },
  {
    key: "JJSEA",
    value: "JJSEA ESG",
    image: "/images/esg/jjsea.png",
    summary:
      "Cross-cutting ESG disclosures that apply broadly across industries and geographies.",
    usage:
      "Use when you need a common baseline set of environment, social, and governance metrics.",
    points: [
      "Covers widely-used ESG topics like energy, emissions, people, and ethics",
      "Ideal as a starter pack before mapping to market-specific frameworks",
      "Keeps disclosures framework-agnostic for flexible reporting",
    ],
  },
  {
    key: "SGX",
    value: "Singapore Exchange (SGX) Sustainability Reporting",
    image: "/images/esg/sgx.png",
    summary:
      "Listing rules and sustainability reporting guidelines aligned to international practices.",
    usage: "Best for SGX-listed or Singapore-based sustainability reporting.",
    points: [
      "Comply-or-explain ESG reporting approach",
      "Board accountability and assurance guidance",
      "Local alignment with global frameworks",
    ],
  },
  {
    key: "BURSA",
    value: "Bursa Malaysia",
    image: "/images/esg/bursa.png",
    summary:
      "Malaysian sustainability reporting framework with general disclosures, common indicators, and sector-specific metrics.",
    usage: "Best for Bursa Malaysia-listed companies sustainability reporting.",
    reference: {
      link: "https://my.bursamalaysia.com/learn/bursa-sustain/explorer/sustainability-reporting-guide-and-toolkits-3rd-edition",
      text: "Bursa Malaysia Sustainability Reporting Guide",
    },
    points: [
      "Structured governance and oversight disclosures",
      "Common indicators across key ESG topics",
      "Industry-specific sustainability metrics",
    ],
    subFrameworks: ["bursa_1", "bursa_2"],
  },
  {
    key: "IFRS-1",
    value: "ISSB · IFRS S1 General Requirements",
    image: "/images/esg/issb_ifrs_s1.png",
    summary:
      "General sustainability-related disclosures forming the global baseline for investors.",
    usage:
      "Best for cross-topic sustainability reporting connected to financial statements.",
    points: [
      "Enterprise-value focused sustainability information",
      "Connectivity with IFRS financial reporting",
      "Applies across industries and sustainability topics",
    ],
    reference: {
      link: "https://www.ifrs.org/issued-standards/ifrs-sustainability-standards/ifrs-s1-general-requirements-for-disclosure-of-sustainability-related-financial-information/",
      text: "IFRS S1 Standard",
    },
  },
  {
    key: "IFRS-2",
    value: "ISSB · IFRS S2 Climate-related Disclosures",
    image: "/images/esg/issb_ifrs_s2.png",
    summary:
      "Climate-related disclosure standard aligned with TCFD structure for risks, opportunities, and metrics.",
    usage:
      "Best for climate risk, transition plans, and emissions reporting aligned to IFRS S2.",
    points: [
      "Governance, strategy, risk management, metrics and targets for climate",
      "Scenario analysis and resilience expectations",
      "Emissions, targets, and transition planning disclosures",
    ],
    reference: {
      link: "https://www.ifrs.org/issued-standards/ifrs-sustainability-standards/ifrs-s2-climate-related-disclosures/",
      text: "IFRS S2 Standard",
    },
  },
  {
    key: "GRI",
    value: "Global Reporting Initiative (GRI)",
    image: "/images/esg/gri.png",
    summary:
      "Comprehensive sustainability disclosures across environmental, social and governance topics.",
    usage: "Best for organization-wide sustainability reporting across topics.",
    points: [
      "Broad ESG topics and disclosures",
      "Stakeholder-focused transparency and comparability",
      "Modular structure with topic standards",
    ],
  },
  {
    key: "TCFD",
    value: "Task Force on Climate-related Financial Disclosures (TCFD)",
    image: "/images/esg/tcfd.png",
    summary:
      "Governance, strategy, risk management, and metrics/targets for climate reporting.",
    usage:
      "Best for climate-related risk, governance, and strategy disclosures.",
    points: [
      "Scenario analysis and risk management",
      "Board oversight and management roles",
      "Emissions metrics and target tracking",
    ],
  },
  {
    key: "SASB",
    value: "Sustainability Accounting Standards Board (SASB)",
    image: "/images/esg/sasb.png",
    summary:
      "Industry-specific metrics focused on financial materiality for investors.",
    usage: "Best for investor-focused, industry-specific metrics and KPIs.",
    points: [
      "Industry-focused KPIs and guidance",
      "Materiality-driven metrics and narratives",
      "Complements mainstream financial filings",
    ],
    disabled: true,
  },
  {
    key: "SET",
    value: "SET/FTSE Russell",
    subtitle: "Thailand and FTSE ESG ratings",
    image: "/images/esg/set.png",
    disabled: true,
  },
  {
    key: "ASX",
    value: "ASX",
    subtitle: "Australian Securities Exchange ESG guidelines",
    image: "/images/esg/asx.png",
    disabled: true,
  },
];
